import { useQuery } from "react-query";
import { getAppointmentTypes } from "../api/getAppointmentTypes";

export const useAppointmentTypes = () => {
  return useQuery("appointment-types", getAppointmentTypes);
};
